export default [
  { married: 'verheiratet' },
  { single: 'ledig' },
  { divorced: 'geschieden' },
  { widowed: 'verwitwet' },
];
